import React, { useContext, useEffect, useState } from 'react';
import { landingPageContext } from '../LandingEdits';

interface VideoItem {
  id: string;
  link: string;
}

const getYouTubeThumbnail = (link: string): string => {
  const match = link.match(/(?:v=|\/)([0-9A-Za-z_-]{11})/);
  return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : '/videos/placeholder.jpg';
};

const AdminVideoCornerEditor: React.FC = () => {
  const context = useContext(landingPageContext);
  if (!context) throw new Error('Must be used inside LandingEdits');

  const { landingDetails, setLandingDetails } = context;
  const [videos, setVideos] = useState<VideoItem[]>([]);

  useEffect(() => {
    setVideos(landingDetails.video_corner || []);
  }, [landingDetails.video_corner]);

  const handleLinkChange = (id: string, newLink: string) => {
    const updated = videos.map(v => (v.id === id ? { ...v, link: newLink } : v));
    setVideos(updated);
    setLandingDetails(prev => ({ ...prev, video_corner: updated }));
  };

  const handleAddVideo = () => {
    const newVideo: VideoItem = {
      id: Date.now().toString(),
      link: '',
    };
    const updated = [...videos, newVideo];
    setVideos(updated);
    setLandingDetails(prev => ({ ...prev, video_corner: updated }));
  };

  const handleDeleteVideo = (id: string) => {
    const updated = videos.filter(v => v.id !== id);
    setVideos(updated);
    setLandingDetails(prev => ({ ...prev, video_corner: updated }));
  };

  return (
    <div className="p-6 space-y-8">
      <h2 className="text-2xl font-bold">Video Corner Editor</h2>

      <button
        onClick={handleAddVideo}
        className="bg-green-600 text-white px-4 py-2 rounded"
      >
        + Add New Video
      </button>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {videos.map(video => (
          <div key={video.id} className="border rounded-xl p-4 shadow space-y-3 min-h-[300px]">
            <img
              src={getYouTubeThumbnail(video.link)}
              alt="Video Thumbnail"
              className="w-full h-[17rem] object-cover rounded"
            />

            <label className="block text-sm font-medium">YouTube Link</label>
            <input
              type="text"
              value={video.link}
              onChange={e => handleLinkChange(video.id, e.target.value)}
              className="w-full border p-2 rounded"
              placeholder="https://youtube.com/..."
            />

            <button
              onClick={() => handleDeleteVideo(video.id)}
              className="bg-red-500 text-white px-4 py-2 rounded w-full"
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminVideoCornerEditor;
